export default "__VITE_ASSET__CfYCGHe$__"